import {
  collection,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  getDocs,
  query,
  orderBy,
  serverTimestamp,
  onSnapshot,
} from 'firebase/firestore';
import { db } from '../firebase';

const VEHICLES_COLLECTION = 'vehicles';

export const subscribeToVehicles = (callback, { availableOnly = false } = {}) => {
  const q = query(collection(db, VEHICLES_COLLECTION), orderBy('sortOrder', 'asc'));

  return onSnapshot(
    q,
    (snapshot) => {
      let vehicles = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
      if (availableOnly) {
        vehicles = vehicles.filter((v) => v.status === 'available');
      }
      callback(vehicles);
    },
    (error) => callback([], error)
  );
};

export const getAllVehicles = async () => {
  const q = query(collection(db, VEHICLES_COLLECTION), orderBy('sortOrder', 'asc'));
  const snapshot = await getDocs(q);
  return snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
};

export const createVehicle = async (vehicleData) => {
  const docRef = await addDoc(collection(db, VEHICLES_COLLECTION), {
    ...vehicleData,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
  return docRef.id;
};

export const updateVehicle = async (id, vehicleData) => {
  await updateDoc(doc(db, VEHICLES_COLLECTION, id), {
    ...vehicleData,
    updatedAt: serverTimestamp(),
  });
};

export const deleteVehicle = async (id) => {
  await deleteDoc(doc(db, VEHICLES_COLLECTION, id));
};
